export const translations = {
    vi: {
        navbar: {
            introduce: 'Giới thiệu',
            solution: 'Giải pháp',
            feature: 'Tính năng',
            contact: 'Liên hệ',
            download: 'Tải ứng dụng',
            login: 'Đăng nhập',
        },
        header: {
            headerTitle: 'Nền Tảng Quản Lý Nội Dung, Quản Lý Học Tập Và Giảng Dạy Trực Tuyến',
            headerDetail: '<b>LCMS i-School</b> cho phép tạo, quản lý, sắp xếp và cung cấp tài liệu đào tạo trực tuyến phục vụ cho quá trình dạy và học.',
        },
        introduce: {
            titleIntroduce: '<span>LCMS i-School</span> là gì?',
            detailIntroduce: {
                first: '<b>LCMS i-School</b> là hệ thống tích hợp toàn diện các công cụ hỗ trợ quản lý, điều hành thông tin giữa gia đình và nhà trường, hỗ trợ hoạt động giảng dạy, học tập và kiểm tra đánh giá học sinh.',
                second: '<b>LCMS i-School</b> hướng đến mục tiêu cung cấp nguồn tài nguyên số hoá, tích hợp ứng dụng dạy học, ôn tập trực tuyến đa dạng, được chia theo từng cấp lớp cụ thể, bám sát khung chương trình giáo dục mầm non, giáo dục phổ thông năm 2018 theo quy định của Bộ Giáo dục và Đào tạo.'
            },
            platformImage: '/images/introduce/platform.svg',
            platformIntroduce: 'Giới thiệu tổng quan',

        },
        solution: {
            title: '<span>Phân quyền linh hoạt</span> theo vai trò',
            admin: {
                title: 'Quản trị viên',
                content: [
                    'Quản lí phân bổ (Giáo viên, kế hoạch, giảng dạy, thời khoá biểu)',
                    'Quản lí tài nguyên',
                    'Quản lí danh mục hệ thống',
                    'Quản lí người dùng',
                    'Quản lí lớp học',
                    'Quản lí cuộc thi',
                    'Quản lí thông báo',
                    'Quản lí yêu cầu hỗ trợ',
                ]
            },
            teacher: {
                title: 'Giáo viên',
                content: [
                    'Quản lí lịch dạy',
                    'Theo dõi kế hoạch giảng dạy',
                    'Quản lí học sinh',
                    'Quản lí tài nguyên dạy và học',
                    'Quản lí bài đã giao',
                    'Quản lí bảng điểm',
                    'Quản lí cuộc thi',
                    'Điểm danh và nhận xét'
                ]
            },
            student: {
                title: 'Học sinh',
                content: [
                    'Theo dõi thời khoá biểu',
                    'Theo dõi và làm bài được giao',
                    'Tham gia cuộc thi',
                    'Sử dụng tài nguyên học tập',
                    'Theo dõi bảng điểm',
                    'Theo dõi thông báo',
                    'Theo dõi thông tin điểm danh và nhận xét'
                ]
            },
            parent: {
                title: 'Phụ huynh',
                content: [
                    'Theo dõi thời khoá biểu',
                    'Theo dõi bài được giao',
                    'Xem kết quả cuộc thi',
                    'Quản lí các con',
                    'Quản lí bảng điểm',
                    'Quản lí thông báo',
                    'Theo dõi thông tin điểm danh và nhận xét'
                ]
            }
        },
        feature: {
            title: 'Điểm khác biệt và vượt trội của i-School',
            features: [
                {
                    title: 'Hỗ trợ đa nền tảng',
                    desc: 'Truy cập dễ dàng trên trình duyệt web và ứng dụng di động.',
                },
                {
                    title: 'Hệ sinh thái tích hợp',
                    desc: 'Kết nối nội dung và dữ liệu đa dạng trong quản lý học tập, đánh giá và ôn luyện.',
                },
                {
                    title: 'Bảo mật cao',
                    desc: 'Tuân thủ Nghị định 13/2023/NĐ-CP về bảo vệ dữ liệu cá nhân.',
                },
                {
                    title: 'Tối ưu hoá thời gian',
                    desc: 'Tự động hóa quy trình quản lý nội dung và đánh giá.',
                },
                {
                    title: 'Học tập cá nhân hóa',
                    desc: 'Cho phép giáo viên tuỳ chỉnh nội dung theo nhu cầu và năng lực của học sinh, nâng cao hiệu quả học tập.',
                },
                {
                    title: 'Bảng điều khiển',
                    desc: 'Cung cấp cái nhìn tổng quan và kết quả học tập, dữ liệu hoạt động được đưa ra giải pháp tối ưu nhằm nâng cao chất lượng giáo dục.',
                }
            ]
        },
        highlight: {
            title: 'Tính năng nổi bật',
            features: {
                first: {
                    title: 'Bảng điều khiển và thống kê theo thời gian thực',
                    itemDetails: [
                        {
                            content: 'Báo cáo quản trị'
                        },
                        {
                            content: 'Báo cáo học tập học sinh'
                        },
                        {
                            content: 'Báo cáo theo kĩ năng'
                        },
                        {
                            content: 'Báo cáo khảo sát'
                        },
                    ]
                },
                second: {
                    title: 'Kho học liệu, nội dung phong phú và đa dạng từ hệ thống',
                    description: 'Trang bị sẵn kho học liệu điện tử từ Eduhome, i-Test dành cho học sinh từ Mầm non đến Đại học.',
                },
                third: {
                    title: 'Quản lý học tập',
                    description: 'Tạo và quản lý thời khóa biểu. Quản lý thời gian biểu theo môn học, lớp học. Điểm danh hằng ngày.',
                },
                four: {
                    title: 'Dạy học trực tuyến',
                    description: 'Tích hợp tính năng dạy học trực tuyến lên nền tảng, giúp giáo viên và học sinh kết nối mọi lúc, mọi nơi.',
                },
                five: {
                    title: 'Tạo sự kiện, lịch biểu & thông báo',
                    description: 'Tổ chức hoạt động giảng dạy một cách khoa học.',
                },
                six: {
                    title: 'Giao bài, chấm điểm bài tập cho học sinh',
                    description: 'Giao bài tập Sách giáo khoa, Sách bài tập có sẵn trên Eduhome, i-Test. Chấm và công bố điểm trực tiếp.',
                }
            }
        },
        device: {
            title: 'Thiết bị sử dụng',
            desc: 'i-School phát triển đồng thời phiên bản web và ứng dụng di động, mang đến trải nghiệm tối ưu cho người dùng.',
            web: {
                title: 'Trình duyệt web',
                desc: 'Dành cho <b>Quản trị viên</b>, <b>Nhà trường</b>, <b>Giáo viên</b>, <b>Học sinh</b> và <b>Phụ huynh</b> với các tính năng chính:',
                features: [
                    'Quản lý vận hành',
                    'Giao bài tập, chấm điểm',
                    'Thông kê học tập'
                ]
            },
            mobile: {
                title: 'Ứng dụng di động',
                desc: 'Phiên bản ứng dụng dành cho <b>Học sinh</b> và <b>Phụ huynh</b>, tiếp tục thực hiện các tính năng chính:',
                features: [
                    'Làm bài',
                    'Thời khóa biểu',
                    'Theo dõi điểm số'
                ]
            }
        },
        contact: {
            title: 'Tư vấn - Hỗ trợ - Đồng hành',
            desc: 'Đội ngũ DTP luôn sẵn sàng đồng hành, lắng nghe và hỗ trợ Quý Đối tác, Quý Khách hàng trong thời gian sớm nhất.',
            workplace: ' Đơn vị công tác',
            name: 'Họ và tên',
            phone: 'Số điện thoại',
            email: 'Địa chỉ email',
            message: 'Để lại lời nhắn cho chúng tôi ở đây',
            submit: 'Gửi',
        },
        footer: {
            title: "TRỤ SỞ CHÍNH",
            nameCompany: 'CÔNG TY TNHH CÔNG NGHỆ GIÁO DỤC DTP',
            address: 'Tầng 5-6-7 Cityland Tower, 168 Phan Văn Trị, Phường An Nhơn, Thành phố Hồ Chí Minh, Việt Nam',
            website: 'i-school.vn',
            email: 'info@dtp-education.com',
            hotline: '1800 6242',
            phone: '+84 (28) 38 456 936 – 38 456 937 (Ngoài giờ hành chính)',
            tax: 'MST: 0318613368',
            copyrightDate: 'Giấy phép hoạt động kinh doanh điện tử số 0318613368 cấp ngày 08/08/2024.',
            copyrightWarning: '® Cấm sao chép dưới mọi hình thức nếu không có sự chấp thuận bằng văn bản.',
            copyright: 'Ghi rõ nguồn i-school.vn khi phát hành lại thông tin từ website này.',
            bottomText: '© 2025 Bản quyền thuộc về Education Solutions Viet Nam.,Ltd',
            ecosystem: 'Hệ sinh thái giáo dục số DTP',
            connectWithUs: ' Kết nối với chúng tôi',
        }
    },
    en: {
        navbar: {
            introduce: 'About us',
            solution: 'Solutions',
            feature: 'Features',
            contact: 'Contact us',
            download: 'Download app',
            login: 'Login',
        },
        header: {
            headerTitle: 'A Foundation for Online Content, Learning, and Teaching Management',
            headerDetail: '<b>LCMS i-School</b> enables the creation, management, organization, and delivery of online training materials to support the teaching and learning process.',
        },
        introduce: {
            titleIntroduce: 'What is <span>LCMS i-School</span>?',
            detailIntroduce: {
                first: '<b>LCMS i-School</b> is a comprehensive system that integrates tools to support information management and communication between families and schools, as well as to assist teaching, learning, and student assessment activities.',
                second: '<b>LCMS i-School</b> aims to provide a rich source of digitized educational resources and integrated applications for teaching and online revision. These resources are categorized by specific grade levels and aligned with the 2018 Early Childhood and General Education Curriculum Framework issued by the Ministry of Education and Training.'
            },
            platformImage: '/images/introduce/platform-en.svg',
            platformIntroduce: 'Overview',

        },
        solution: {
            title: '<span>Flexible Role-Based</span> Access Control',
            admin: {
                title: 'Administrator (Admin)',
                content: [
                    'Manage allocations (Teachers, teaching plans, schedules)',
                    'Manage resources',
                    'Manage system categories',
                    'Manage users',
                    'Manage classes',
                    'Manage competitions',
                    'Manage notifications',
                    'Manage support requests',
                ]
            },
            teacher: {
                title: 'Teacher',
                content: [
                    'Manage teaching schedules',
                    'Track teaching plans',
                    'Manage students',
                    'Manage teaching and learning resources',
                    'Manage assigned assignments',
                    'Manage gradebooks',
                    'Manage competitions',
                    'Take attendance and provide feedback'
                ]
            },
            student: {
                title: 'Student',
                content: [
                    'Track schedules',
                    'Track and complete assignments',
                    'Participate in competitions',
                    'Utilize learning resources',
                    'Track grades',
                    'Track notifications',
                    'Track attendance and feedback'
                ]
            },
            parent: {
                title: 'Parent',
                content: [
                    'Track schedules',
                    'Track assigned assignments',
                    'View competition results',
                    'Manage children',
                    'Manage grades',
                    'Manage notifications',
                    'Track attendance and feedback'
                ]
            }
        },
        feature: {
            title: 'The unique and outstanding features of LCMS i-School',
            features: [
                {
                    title: 'Multi-platform Support',
                    desc: 'Access content on the web and mobile applications.',
                },
                {
                    title: 'Multi-functional Integration',
                    desc: 'Integrate content, data, and learning management systems.',
                },
                {
                    title: 'High Security',
                    desc: 'Comply with Decree 13/2023/ND-CP on personal data protection.',
                },
                {
                    title: 'Time Optimization',
                    desc: 'Automate content management and assessment processes.',
                },
                {
                    title: 'Personalized Learning',
                    desc: 'Allows teachers to customize content based on students\' needs and abilities, enhancing learning effectiveness.',
                },
                {
                    title: 'Dashboard',
                    desc: 'Provides an overview of learning results and activities, offering optimized solutions to enhance educational quality.',
                }
            ]
        },
        highlight: {
            title: 'Outstanding Features',
            features: {
                first: {
                    title: 'Dashboard and Real-time Statistics',
                    itemDetails: [
                        {
                            content: 'Administrative Reports'
                        },
                        {
                            content: 'Student Learning Reports'
                        },
                        {
                            content: 'Report by skill'
                        },
                        {
                            content: 'Survey Reports'
                        },
                    ]
                },
                second: {
                    title: 'Rich and Diverse Resource Library',
                    description: 'Equipped with a digital resource library from Eduhome and i-Test for students from Kindergarten to University.',
                },
                third: {
                    title: 'Learning Management',
                    description: 'Create and manage schedules. Manage schedules by subject, class, and student attendance.',
                },
                four: {
                    title: 'Online Teaching',
                    description: 'Integrate online teaching features into the platform, enabling teachers and students to connect anytime, anywhere.',
                },
                five: {
                    title: 'Create Events, Calendars & Notifications',
                    description: 'Organize teaching activities in a systematic manner.',
                },
                six: {
                    title: 'Assigning and Grading Assignments',
                    description: 'Assign textbook and workbook exercises available on Eduhome and i-Test. Grade and publish scores directly.',
                }
            }
        },
        device: {
            title: 'Supported Devices',
            desc: 'i-School LCMS is developed for both web and mobile platforms, delivering an optimal user experience.',
            web: {
                title: 'Browsers',
                desc: 'Designed for <b>Administrators</b>, <b>Schools</b>, <b>Teachers</b>, <b>Students</b> and <b>Parents</b> with key features including:',
                features: [
                    'Operational management',
                    'Assignment and grading',
                    'Learning analytics',
                ]
            },
            mobile: {
                title: 'Mobile App',
                desc: 'The mobile version is designed for <b>Students</b> and <b>Parents</b>,  offering key features such as:',
                features: [
                    'Complete assignments',
                    'View class schedule',
                    'Track academic performance',
                ]
            }
        },
        contact: {
            title: 'Consultation - Support - Partnership',
            desc: 'Our team is always ready to accompany, listen, and provide timely support to our valued partners and customers.',
            workplace: 'Workplace',
            name: 'Full Name',
            phone: 'Phone Number',
            email: 'Email Address',
            message: 'Leave a message for us here',
            submit: 'Submit',
        },
        footer: {
            title: "HEAD OFFICE",
            nameCompany: 'DTP EDUCATION TECHNOLOGY COMPANY LIMITED',
            address: '5th-6th-7th Floor, Cityland Tower, 168 Phan Van Tri, An Nhon Ward, Ho Chi Minh City, Vietnam',
            website: 'i-school.vn',
            email: 'info@dtp-education.com',
            hotline: '1800 6242',
            phone: '+84 (28) 38 456 936 - 38 456 937 (Outside business hours)',
            tax: 'Business Registration No: 0318613368',
            copyrightDate: 'Obtained business license in the number 0318613368 issued on 08/08/2024.',
            copyrightWarning: '© Reproduction in any form without written permission is prohibited.',
            copyright: 'Please clearly state the source i-school.vn when re-publishing information from this website.',
            bottomText: '© 2025 2025 All rights reserved by Education Solutions Viet Nam Co., Ltd.',
            ecosystem: 'DTP Digital Education Ecosystem',
            connectWithUs: 'Connect with Us',
        },
    }
};
